import DataTable from "./../../../shared/components/DataTable";
import { useTimeLoggerContext } from "./TimeLoggerContext";

export default function TimeLogsTable() {
  const { timeLogs } = useTimeLoggerContext();
  const timeLogsColumns = [
    {
      text: "de",
      key: 1,
      dataField: "start",
    },
    {
      text: "à",
      key: 2,
      dataField: "end",
    },
    {
      text: "duré",
      key: 3,
      dataField: "duration",
    },
  ];

  return <DataTable key={"id"} columns={timeLogsColumns} data={timeLogs} />;
}
